import { PbError } from '@owner/errors'

class GenericError extends PbError {
  constructor(args) {
    super(args.message, args)
    this.name = 'GenericError'
    this.code = args.code
    this.message = args.message
    this.status = args.status
  }
}

export { GenericError }
